import { NetworkConfiguration } from "../../network/networkConfriguation";
import { callAPI } from "../../network/networkConnection";
import { fetchToken } from "../../lib/globalApiClient";

const getSubscription = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.SUBSCRIPTION_PLANS,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const subscribeProduct = (id, searchKeyword = '') => {
  return new Promise((resolve, reject) => {
    const url = process.env.REACT_APP_APIUrl +
      NetworkConfiguration.SUBSCRIBE_PRODUCT +
      `/${id}` +
      (searchKeyword ? `?search=${encodeURIComponent(searchKeyword)}` : '');

    callAPI(
      url,
      "POST",  // Changed from GET to POST to match backend route
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const unSubscribeProduct = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.UNSUBSCRIBE_PRODUCT +
      `/${id}`,
      "POST",  // Changed from GET to POST to match backend route
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const deleteSubscription = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.DELETE_SUBSCRIPTION +
      `/${id}`,
      "DELETE",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const addSubscription = (payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADD_SUBSCRIPTION,
      "POST",
      {
        "Content-Type": "application/json",
      },
      payload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getSubscriptionById = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.SUBSCRIPTION_BY_ID +
      id,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const editSubscription = (payload, id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.EDIT_SUBSCRIPTION +
      id,
      "PUT",
      {
        "Content-Type": "application/json",
      },
      payload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const generateDescription = (productName, productCategory, targetLanguage = "en") => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = await fetchToken();
      callAPI(
        process.env.REACT_APP_APIUrl1688 + "/generate-description",
        "POST",
        {
          "Content-Type": "application/json",
          "X-API-Token": token
        },
        JSON.stringify({
          productName,
          targetLanguage,
          productCategory
        })
      )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (tokenError) {
      reject(tokenError);
    }
  });
};

export const SubscriptionApiService = {
  getSubscription,
  deleteSubscription,
  addSubscription,
  subscribeProduct,
  unSubscribeProduct,
  getSubscriptionById,
  editSubscription,
  generateDescription,
};
